import { useExpertReportPeriod } from '@features/expertReports'
import type { UseExpertReportPeriodResult } from '@features/expertReports'

/**
 * Period shown in the balance sheet report, shared by the Assets and Liabilities and equity tabs. Stored as an
 * encoded string in the `period` URL query param. On a fresh load it defaults to the organization's current
 * fiscal year.
 */
export const useExpertBalanceSheetPeriod = (): UseExpertReportPeriodResult => useExpertReportPeriod()
